import { render, staticRenderFns } from "./EPDS.vue?vue&type=template&id=6b670276&scoped=true&"
import script from "./EPDS.vue?vue&type=script&lang=js&"
export * from "./EPDS.vue?vue&type=script&lang=js&"
import style0 from "./EPDS.vue?vue&type=style&index=0&id=6b670276&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b670276",
  null
  
)

export default component.exports